import React, { useLayoutEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import './BloodyMaryScare.less';

const PHASES = {
  SCARE: 'scare',
  FADE_OUT: 'fadeOut',
};

const SCARE_HOLD_MS = 1600;
const FADE_OUT_MS = 400;

const IMAGE_SRC = '/assets/easter-eggs/bloody-mary.webp';
const AUDIO_SRC = '/assets/easter-eggs/scream.mp3';

const BloodyMaryScare = ({ active, onDone }) => {
  const [phase, setPhase] = useState(PHASES.SCARE);
  const timersRef = useRef([]);
  const audioRef = useRef(null);
  const onDoneRef = useRef(onDone);
  onDoneRef.current = onDone;

  useLayoutEffect(() => {
    const audio = new Audio(AUDIO_SRC);
    audio.preload = 'auto';
    audio.load();
    audioRef.current = audio;

    const img = new Image();
    img.src = IMAGE_SRC;

    return () => {
      audio.pause();
      audio.src = '';
      audioRef.current = null;
    };
  }, []);

  useLayoutEffect(() => {
    const clearTimers = () => {
      timersRef.current.forEach(clearTimeout);
      timersRef.current = [];
    };

    const schedule = (fn, ms) => {
      const id = setTimeout(fn, ms);
      timersRef.current.push(id);
    };

    if (!active) {
      clearTimers();
      setPhase(PHASES.SCARE);
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
      return undefined;
    }

    setPhase(PHASES.SCARE);
    if (typeof navigator !== 'undefined' && navigator.vibrate) {
      navigator.vibrate([50, 30, 80]);
    }
    const audio = audioRef.current;
    if (audio) {
      audio.currentTime = 0;
      audio.play().catch(() => {});
    }

    schedule(() => {
      setPhase(PHASES.FADE_OUT);
      schedule(() => {
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
        }
        if (onDoneRef.current) onDoneRef.current();
      }, FADE_OUT_MS);
    }, SCARE_HOLD_MS);

    return clearTimers;
  }, [active]);

  if (!active) return null;

  return ReactDOM.createPortal(
    (
      <div
        className={`bloody-mary-scare bloody-mary-scare--${phase}`}
        aria-hidden="true"
      >
        <div className="bloody-mary-scare__shake">
          <img
            className="bloody-mary-scare__img"
            src={IMAGE_SRC}
            alt=""
          />
        </div>
      </div>
    ),
    document.body,
  );
};

export default BloodyMaryScare;
